//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconNavBriefcase(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M22 6H17.47L14.95 3H9.05L6.53 6H2V8H20V14H13V12H11V14H4V10H2V21H22V6ZM9.14 6L9.98 5H14.01L14.85 6H9.14ZM20 19H4V16H11V17H13V16H20V19Z" fill="currentColor" /></svg>;
}
export default IconNavBriefcase;